import { c as _c } from "react/compiler-runtime";
type ErrorProps = {
  message: string;
};
const ErrorComponent = t0 => {
  const $ = _c(2);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = <p className="text-body-2 text-secondary">{message}</p>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ErrorComponent;